exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-item.trip-item.sub {\n    text-indent: 3em;\n}", ""]);
